export default {
  props: {
    image: {
      type: Object,
    },

    title: {
      type: String,
    },

    body: {
      type: String,
    },
  },
}
